import { Fragment, useState, useEffect, useMemo } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {
  BrowserRouter,
  Route,
  Link,
  Switch,
  Redirect,
  useHistory,
} from "react-router-dom";
import { axios, productStats } from "../Network";
import CartDetails from "./Cart";
import ".././App.css";
import { placeOrderState } from "../Utils/PlaceOrderService";
import PaymentOption from "./PaymentOption";
import { RadioGroup } from "@headlessui/react";

import moment from "moment";
import { compareAsc, format, setHours, setMinutes } from "date-fns";
var store = {
  paymentOptions: [
    {
      itemName: "Bank Deposit",
      itemDetails: "1923-2392-2932",
      status: true,
      items: [
        {
          itemName: "Metrobank",
          itemDetails: "0413 7979 3913 8",
          status: true,
          icon_url:
            "https://i0.wp.com/onlinequickguide.com/wp-content/uploads/2020/04/Metrobank-Mobile-Banking.png?fit=349%2C356&ssl=1",
        },
        {
          itemName: "BPI",
          itemDetails: "1359 4822 44",
          status: true,
          icon_url:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT0eVsCGZPBThGljYA7nV6zkVnqJRR0HWGQfeSLSz_a6JbFXYrIubu53qweATY7EwzAEqY&usqp=CAU",
        },
      ],
      key: "xx1",
    },
    {
      itemName: "Billease",
      key: "xx2",
      itemDetails: "0917 843 4776",
      status: true,
      icon_url:
        "https://getcash.ph/wp-content/uploads/2021/01/Gcash-logo-Transparent-500x500-1.png",
    },
    {
      itemName: "GCash",
      key: "xxdsa2",
      itemDetails: "0917 843 4776",
      status: true,
      icon_url:
        "https://getcash.ph/wp-content/uploads/2021/01/Gcash-logo-Transparent-500x500-1.png",
    },
    {
      itemName: "Credit/Debit Card",
      key: "xx3",
      itemDetails: "Visa/Master",
      status: true,
      icon_url:
        "https://static.vecteezy.com/system/resources/thumbnails/022/100/815/small/master-card-logo-transparent-free-png.png",
    },
  ],
};
export default function Example(props) {
  let [plan, setPlan] = useState("startup");

  const [show, setShow] = useState(false);
  const [status, setStatus] = useState(false);
  const [customersName, setCustomersName] = useState("");
  const [mobile, setCustomersMobile] = useState("");
  const [isAgree, setDidAgree] = useState(false);
  const [orderDetails, setData] = useState(null);
  let [isOpen, setIsOpen] = useState(false);
  let [isCart, setDisplayType] = useState(true);
  let [currentView, setCurrentView] = useState(1);
  const [userDate, setDate] = useState(null);
  const history = useHistory();
  function closeModal() {
    setIsOpen(false);
  }
  var dummyData = [
    {
      id: "60ac80ee9d794c9bdc5363ff",
      subtitle:
        'Bobo Balloon with Assorted Flowers (Color of ribbons and balloons can be customized) (38" in height',
      title: "SmartDesk Frame",
      price: "15000",
      imgUrl:
        "https://clouddisk.alibaba.com/file/redirectFileUrl.htm?appkey=OneChat&id=687739271&parentId=648781579&secOperateAliId=MC1IDX1kM-MR-7BPeDBIwbElTZ3pPEOK07tBVtyj8FpUP6LloWGv1vCw-QwSZ61E9LoiHzz&fileAction=imagePreview",
      storeOwner: "5ff00ddaeb2f5d0940dfa186",
      type: "BoboBalloon",
      imageDetails: {
        host: "https://nidz.fra1.digitaloceanspaces.com",
        filename: "1621917929948-101.jpg",
        link: "https://localflowershop.sgp1.digitaloceanspaces.com/product/1621917929948-101.jpg",
      },
    },
    {
      id: "60ac80ee9d794c9bdc5363ff",
      subtitle:
        'Bobo Balloon with Assorted Flowers (Color of ribbons and balloons can be customized) (38" in height',
      title: "Installation ",
      price: "1000",
      imgUrl:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTAPvF103DKkAHj3OHyvKVnfOE3bzBXjalwtQ10lZZeZD4Wfo9jsOxlrrmNxMWv8FWZzqU&usqp=CAU",
      storeOwner: "5ff00ddaeb2f5d0940dfa186",
      type: "BoboBalloon",
      imageDetails: {
        host: "https://nidz.fra1.digitaloceanspaces.com",
        filename: "1621917929948-101.jpg",
        link: "https://localflowershop.sgp1.digitaloceanspaces.com/product/1621917929948-101.jpg",
      },
    },
    {
      id: "60ac80ee9d794c9bdc5363ff",
      subtitle:
        'Bobo Balloon with Assorted Flowers (Color of ribbons and balloons can be customized) (38" in height',
      title: "Table Top - Mahogany ",
      price: "1000",
      imgUrl: "https://cdn-icons-png.flaticon.com/512/972/972830.png",
      storeOwner: "5ff00ddaeb2f5d0940dfa186",
      type: "BoboBalloon",
      imageDetails: {
        host: "https://nidz.fra1.digitaloceanspaces.com",
        filename: "1621917929948-101.jpg",
        link: "https://localflowershop.sgp1.digitaloceanspaces.com/product/1621917929948-101.jpg",
      },
    },
  ];

  const [payment, setSelectePayment] = useState({
    itemName: "GCash",
    key: "xx2",
    itemDetails: "0917 843 4776",
    status: true,
    icon_url:
      "https://getcash.ph/wp-content/uploads/2021/01/Gcash-logo-Transparent-500x500-1.png",
  });
  useEffect(() => {
    let userSeletedDate = localStorage.getItem("userQ");
    var date = JSON.parse(userSeletedDate);
    if (date != null) {
      setDate(moment(date.date).toDate());
    } else {
      setDate(moment(setHours(setMinutes(new Date(), 0), 9)));
    }
  }, []);
  const newDate = () => {
    var new_date = moment(new Date());
    return new_date.add(1, "days");
  };

  function openModal() {
    setIsOpen(true);
  }
  useEffect(() => {
    // setShow(true)
  }, []);

  function manageDrawer() {
    props.showDrawer(!show);
    setShow(!show);
  }

  const people = [
    {
      id: 1,
      unavailable: true,
      name: "Michael",
    },
  ];

  function removeItem(e) {
    props.removeItem(e);
  }

  async function recoredAddCalendar() {
    try {
      const data = {
        storeOwner: "Nidz",
        cType: "calendar",
        cName: "web",
        data: props.items,
        date: new Date(),
      };
      const response = await productStats.put("/Items", data);
      alert("Not ready");
      return response;
    } catch (error) {}
  }
  const successCartContent = () => {
    return (
      <div className="my-8 inline-block w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
        {/* <span className="text-sm fext-blue-200">Date selected {moment(userDate).format("MMM DD, YYYY  h:mm A").toString()}</span> */}

        <Dialog.Title
          as="h3"
          className="text-lg font-medium leading-6 text-gray-900"
        >
          Congratulations! Your order was placed successfully
        </Dialog.Title>
        {/* <h3 className="mt-2 mb-5 text-black text-xs   flex leading-5">
   {moment(userDate).format("MMMM Do YYYY ").toString()}<img src="https://img.icons8.com/material-outlined/344/calendar--v1.png" className="h-4 w-4 mx-2 mt-1" />
   </h3> */}
        <div
          className="mt-5  overflow-auto"
          style={{
            height: props.items.length <= 3 ? "auto" : 400,
            overflow: "auto",
          }}
        ></div>
        <div className="mt-4">
          <img
            src="https://gatesbbq.com/wp-content/uploads/2017/04/checkmarksuccess.gif"
            className="h-auto w-auto"
          />
          <div className=" margin:  20rem mb-90 sticky my-10 content-center text-4xl font-bold tracking-tight   text-gray-900 sm:text-center sm:text-2xl md:text-6xl lg:text-center">
            {orderDetails.orderReference}
            <label
              className=" mb-2 mt-5 block text-xs font-light tracking-wide text-gray-700"
              for="grid-first-name"
            >
              Copy your Reference Code
            </label>
          </div>
        </div>
      </div>
    );
  };
  const onClickUrl = (url) => {
    window.open(url, "_blank");
  };
  const orderCartContent = () => {
    return (
      <div className="my-8 inline-block w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
        {/* <span className="text-sm fext-blue-200">Date selected {moment(userDate).format("MMM DD, YYYY  h:mm A").toString()}</span> */}

        <Dialog.Title
          as="h3"
          className="text-lg font-medium leading-6 text-gray-900"
        >
          Your Cart
        </Dialog.Title>
        <h3 className="mb-5 mt-2 flex text-xs   leading-5 text-black">
          {moment().add(4, "w").format("MMMM DD, YYYY").toString()}
          <img
            src="https://img.icons8.com/material-outlined/344/calendar--v1.png"
            className="mx-2 mt-1 h-4 w-4"
          />
          (Date of Completion)
        </h3>
        <div
          className="mt-5  overflow-auto"
          style={{
            height: props.items.length <= 3 ? "auto" : 400,
            overflow: "auto",
          }}
        >
          <p className="mt-10 text-xs font-bold text-gray-500">Pickup</p>
          <CartDetails
            items={props.items}
            removeItem={(e) => removeItem(e)}
            showDelete={false}
          />
        </div>

        <div className="mt-4">
          {1 ? null : (
            <div
              className="mb-4"
              style={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p class="text-xs text-red-500 "> FLOWERS REQUIRED</p>
              <p category="c1" style={{ marginTop: 10 }}>
                Sorry, you can't purchase without flowers.
              </p>
            </div>
          )}
          <input
            type="text"
            id="agree"
            onChange={(e) => setCustomersName(e.nativeEvent.target.value)}
            placeHolder=" Type Customer's Name "
            className="m-2 mb-2 h-10 w-full rounded-full border-2 border-gray-200 p-2 text-sm font-extralight"
          />
          <input
            type="text"
            id="agree"
            onChange={(e) => setCustomersMobile(e.nativeEvent.target.value)}
            placeHolder=" Type Customer's Mobile # "
            className="m-2 mb-5 h-10 w-full rounded-full border-2 border-gray-200 p-2 text-sm font-extralight"
          />

          <div class="mb-4 mt-6 flex">
            <label class="flex items-center">
              <input
                type="checkbox"
                id="agree"
                onChange={(e) => setDidAgree(!isAgree)}
                class="form-checkbox"
              />

              <span class="ml-2 text-sm">
                I agree of the{" "}
                <a
                  class="text-sm underline"
                  href="https://www.smartdeskph.com/terms"
                >
                  Terms & Condition
                </a>
              </span>
            </label>
          </div>
          <button
            onClick={() =>
              onClickUrl(
                "https://www.lazada.com.ph/products/standing-desk-dual-motor-with-solid-wood-jointer-mahogany-table-top-smartdeskph-i3290383845-s26391804337.html?",
              )
            }
            type="button"
            class="font-bold text-blue-700 ease focus:shadow-outline m-2 mb-4 select-none rounded-full border border-black bg-white px-4 py-2 text-black transition duration-500 hover:bg-gray-200 focus:outline-none"
          >
            Checkout via LAZADA
          </button>
          {/* <span className='line-through text-red-600 ml-2 mr-2'>{props.originalPrice}</span> */}
          <button
            type="button"
            //  style={{opacity:0.8}}
            disabled={
              isAgree ? (customersName.length >= 3 ? false : true) : true
            }
            className={`inline-flex  justify-center rounded-full border border-transparent px-4 py-2 text-sm font-medium text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2  ${isAgree ? (customersName.length >= 3 ? "bg-black hover:bg-gray-700  " : "bg-gray-200") : "bg-gray-200"}  `}
            onClick={() => submitOrder()}
          >
            {status ? "Please wait..." : `Submit Order   ${props.totalPrice} `}
            {status ? (
              <svg
                role="status"
                class="mr-3 mt-1  inline h-4 w-4 animate-spin text-white"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="#E5E7EB"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentColor"
                />
              </svg>
            ) : (
              <a href={validateAddons ? "/Cart" : "javascript:void(0);"}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mx-2 mt-1 h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
              </a>
            )}
          </button>
        </div>
      </div>
    );
  };
  const submitOrder = () => {
    setStatus(true);
    try {
      placeOrderState(props.items, customersName, mobile).then((item) => {
        setData(item.data.results);
        setDisplayType(false);
        setStatus(false);
        setTimeout(() => {
          window.location.reload(true);
        }, 6000);
      });
    } catch (error) {
      console.log("error", error);
      placeOrderState(props.items, "none", mobile).then((item) => {
        setData(item.data.results);
        setDisplayType(false);
        setStatus(false);
        setTimeout(() => {
          window.location.reload(true);
        }, 6000);
      });
    }
  };
  const validateTypeContent = () => {
    return isCart ? orderCartContent() : successCartContent();
  };

  const validateAddons = useMemo(() => {
    return true;
    // var required = 1
    // let allowed =  props.items.filter((item: { type: string; }) =>   item.type != "Food" && item.type != "Tart-Addons" && item.type != "Gifts" )
    // return  allowed.length  >= required ? true : false
  }, [props.items]);
  function redirectCheckout() {
    let path = `Cart`;
    props.history.push(path);
  }
  function cart() {
    return (
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={closeModal}
        >
          <div className="min-h-screen bg-black bg-opacity-60 px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              {/* {orderCartContent()} */}

              {validateTypeContent()}
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  }
  function customerDetails() {
    return (
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={closeModal}
        >
          <div className="my-8 inline-block w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
            <Dialog.Title
              as="h3"
              className="text-lg font-medium leading-6 text-gray-900"
            >
              Your Cart
            </Dialog.Title>
          </div>
        </Dialog>
      </Transition>
    );
  }
  function detectCartView(e) {
    switch (e) {
      case 1:
        return cart();
        break;
      case 2:
        return customerDetails();
      default:
        return <>Empty</>;
        break;
    }
  }
  return (
    <div>
      {cart()}
      <div
        hidden
        onClick={() => openModal()}
        className="full  float-right flex animate-pulse items-center justify-center rounded-full  border-2 border-white bg-black px-4 py-3  font-medium hover:bg-gray-900 md:px-10 md:py-4 md:text-lg"
        style={{
          float: "bottom",
          position: "fixed",
          marginLeft: "45%",
          position: "fixed",
          right: 20,
          top: 40,
          zIndex: 20,
        }}
      >
        {show ? (
          <span class="relative  inline-flex h-3 w-3 animate-ping rounded-full bg-gray-900" />
        ) : null}
        <a onClick={() => openModal()}>
          <div class="flex  text-center  ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="white"
              viewBox="0 0 24 24"
              stroke="white"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.5}
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            {/* <img className="animated  zoomInUp delay-2s mx-1.5" onClick={() => openModal()} style={{ height: 25, color: 'white' }} src={'https://www.pngkey.com/png/full/307-3071593_accessories-shopping-cart-icon-white.png'} /> */}
            {props.items.length === 0 ? null : (
              <>
                <p
                  class="base mx-0 text-center"
                  onClick={() => openModal()}
                  style={{ color: "white" }}
                ></p>
                <p class="base text-center" style={{ color: "white" }}>
                  {props.items.length}
                </p>{" "}
              </>
            )}
          </div>
        </a>
      </div>
    </div>
  );
}
